import { createApp, h } from 'vue';
import { createI18n } from 'vue-i18n';
import { currentLang } from '@/helpers';
import router from './routes/routerIndex';
import store from './store/index';
import boot from './boot.vue';
import translations from '../i18n/translation';
const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: currentLang,
    messages: translations
});
const app = createApp({
    render: () => h(boot)
});
app.use(i18n);
app.use(router);
app.use(store);
app.mount('#bd-internal');
// // Listen for changes to localStorage
// if (window.addEventListener) {
//     window.addEventListener('storage', sessionStorageTransfer, false)
// } else {
//     (window as any).attachEvent('onstorage', sessionStorageTransfer);
// }
// // Ask other tabs for session storage (this is ONLY to trigger event)
// if (!sessionStorage.length) {
//     localStorage.setItem('getSessionStorage', 'foobar')
//     localStorage.removeItem('getSessionStorage')
// }
